// Tab navigation component for Platform Settings
import React from "react";

const SettingsTabNav = ({
  activeTab,
  onTabChange,
  unsavedChanges = false,
  hasUnsavedChanges,
  showDemoTab = false,
}) => {
  const pendingChanges =
    typeof hasUnsavedChanges === "boolean"
      ? hasUnsavedChanges
      : unsavedChanges;

  const tabs = [
    { id: "fees", label: "💰 Fees & Revenue", icon: "💰" },
    { id: "subscriptions", label: "📅 Subscriptions", icon: "📅" },
    { id: "homepage", label: "🏠 Homepage", icon: "🏠" },
    {
      id: "storefront-gating",
      label: "🛡️ Storefront Gating",
      icon: "🛡️",
    },
    { id: "sms", label: "📱 SMS & Marketing", icon: "📱" },
    { id: "business", label: "🏢 Business Rules", icon: "🏢" },
    { id: "booth-rental", label: "🏪 Booth Rental", icon: "🏪" },
    { id: "looks", label: "👁️ Looks Engagement", icon: "👁️" },
    { id: "security", label: "🔒 Security & System", icon: "🔒" },
    ...(showDemoTab
      ? [{ id: "demo", label: "🧪 Demo Mode", icon: "🧪" }]
      : []),
  ];

  const handleTabClick = (tabId) => {
    if (pendingChanges) {
      const confirm = window.confirm(
        "You have unsaved changes. Are you sure you want to switch tabs? Your changes will be lost.",
      );
      if (!confirm) return;
    }
    onTabChange(tabId);
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        borderBottom: "2px solid #e5e7eb",
        marginBottom: "32px",
        flexWrap: "wrap",
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            style={{
              padding: "12px 20px",
              border: "none",
              background: isActive ? "#3b82f6" : "transparent",
              color: isActive ? "white" : "#6b7280",
              fontWeight: isActive ? "600" : "500",
              fontSize: "14px",
              cursor: "pointer",
              borderRadius: "8px 8px 0 0",
              transition: "all 0.2s",
              position: "relative",
              bottom: "-2px",
              borderBottom: isActive ? "2px solid #3b82f6" : "none",
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.target.style.background = "#f3f4f6";
                e.target.style.color = "#374151";
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.target.style.background = "transparent";
                e.target.style.color = "#6b7280";
              }
            }}
          >
            {tab.label}
            {pendingChanges && isActive && (
              <span
                style={{
                  display: "inline-block",
                  width: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  background: "#fbbf24",
                  marginLeft: "8px",
                  verticalAlign: "middle",
                }}
                title="Unsaved changes"
              />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default SettingsTabNav;
